
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.16.0
 * Query Engine version: 1c57fdcd7e44b29b9313256c76699e91c3ac3c43
 */
Prisma.prismaVersion = {
  client: "6.16.0",
  engine: "1c57fdcd7e44b29b9313256c76699e91c3ac3c43"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  firstName: 'firstName',
  lastName: 'lastName',
  role: 'role',
  banned: 'banned',
  banReason: 'banReason',
  banExpires: 'banExpires',
  lastLoginMethod: 'lastLoginMethod',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId',
  expiresAt: 'expiresAt',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  impersonatedBy: 'impersonatedBy',
  activeOrganizationId: 'activeOrganizationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  providerId: 'providerId',
  accountId: 'accountId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  value: 'value',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  logo: 'logo',
  metadata: 'metadata',
  createdAt: 'createdAt'
};

exports.Prisma.MemberScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  organizationId: 'organizationId',
  role: 'role',
  createdAt: 'createdAt'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  inviterId: 'inviterId',
  organizationId: 'organizationId',
  role: 'role',
  status: 'status',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt'
};

exports.Prisma.JwksScalarFieldEnum = {
  id: 'id',
  publicKey: 'publicKey',
  privateKey: 'privateKey',
  createdAt: 'createdAt'
};

exports.Prisma.FileScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  key: 'key',
  name: 'name',
  type: 'type',
  url: 'url',
  size: 'size',
  isPublic: 'isPublic',
  status: 'status',
  userFileId: 'userFileId',
  avatarId: 'avatarId',
  commentId: 'commentId',
  replyId: 'replyId',
  listingId: 'listingId',
  orderIndex: 'orderIndex'
};

exports.Prisma.FileAccessControlScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  fileId: 'fileId',
  userId: 'userId'
};

exports.Prisma.FeaturedListingScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  listingId: 'listingId',
  startDate: 'startDate',
  endDate: 'endDate'
};

exports.Prisma.ListingScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  slug: 'slug',
  status: 'status',
  businessId: 'businessId',
  title: 'title',
  description: 'description',
  details: 'details'
};

exports.Prisma.ForLeaseScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  listingId: 'listingId',
  availableFrom: 'availableFrom',
  leaseTermMonths: 'leaseTermMonths'
};

exports.Prisma.AuctionFormatScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  listingId: 'listingId',
  auctionStartDate: 'auctionStartDate',
  auctionEndDate: 'auctionEndDate',
  startingBid: 'startingBid',
  reserveBidAmount: 'reserveBidAmount',
  bidIncrement: 'bidIncrement',
  winningBidId: 'winningBidId'
};

exports.Prisma.BidScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  auctionId: 'auctionId',
  propertySeekerId: 'propertySeekerId',
  currentBidAmount: 'currentBidAmount',
  placedBy: 'placedBy',
  maxBidAmount: 'maxBidAmount'
};

exports.Prisma.SavedListingScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  listingId: 'listingId',
  personId: 'personId',
  isSaved: 'isSaved'
};

exports.Prisma.CommentScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  listingId: 'listingId',
  userId: 'userId',
  content: 'content'
};

exports.Prisma.ReplyScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  commentId: 'commentId',
  userId: 'userId',
  content: 'content'
};

exports.Prisma.BusinessScalarFieldEnum = {
  slug: 'slug',
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  organizationId: 'organizationId',
  businessName: 'businessName',
  emails: 'emails',
  addresses: 'addresses',
  phoneNumbers: 'phoneNumbers',
  websites: 'websites'
};

exports.Prisma.PropertySeekerScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  biography: 'biography',
  creditScoreRange: 'creditScoreRange',
  annualIncome: 'annualIncome',
  mostRecentEviction: 'mostRecentEviction',
  mostRecentEvictionProvided: 'mostRecentEvictionProvided'
};

exports.Prisma.TenantScreeningCriteriaScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  leaseTermsId: 'leaseTermsId',
  isEnabled: 'isEnabled',
  creditScoreRange: 'creditScoreRange',
  annualIncome: 'annualIncome',
  mostRecentEviction: 'mostRecentEviction'
};

exports.Prisma.ImpersonationLogScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  sessionId: 'sessionId',
  primaryKey: 'primaryKey',
  impersonator: 'impersonator',
  impersonated: 'impersonated',
  before: 'before',
  after: 'after',
  context: 'context',
  database: 'database',
  schema: 'schema',
  table: 'table',
  operation: 'operation',
  committedAt: 'committedAt'
};

exports.Prisma.ImpersonationSessionScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  impersonator: 'impersonator',
  impersonated: 'impersonated',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  isActive: 'isActive',
  sessionData: 'sessionData'
};

exports.Prisma.UserSessionLogScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  userId: 'userId',
  sessionStart: 'sessionStart',
  sessionEnd: 'sessionEnd',
  userAgent: 'userAgent',
  ipAddress: 'ipAddress',
  userCreatedAt: 'userCreatedAt'
};

exports.Prisma.ProfileScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  emails: 'emails',
  phoneNumbers: 'phoneNumbers',
  addresses: 'addresses'
};

exports.Prisma.ResendEmailLogScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  fromEmail: 'fromEmail',
  toEmail: 'toEmail',
  subject: 'subject',
  replyTo: 'replyTo',
  resendMessageId: 'resendMessageId',
  resendError: 'resendError',
  resendStatusCode: 'resendStatusCode',
  resendErrorName: 'resendErrorName',
  userEmail: 'userEmail',
  userName: 'userName',
  category: 'category',
  message: 'message',
  success: 'success'
};

exports.Prisma.ResendWebhookLogScalarFieldEnum = {
  createdAt: 'createdAt',
  createdById: 'createdById',
  updatedAt: 'updatedAt',
  updatedById: 'updatedById',
  deletedAt: 'deletedAt',
  deletedById: 'deletedById',
  id: 'id',
  eventType: 'eventType',
  messageId: 'messageId',
  webhookData: 'webhookData',
  signatureValid: 'signatureValid',
  signatureReceived: 'signatureReceived',
  signatureExpected: 'signatureExpected',
  processedAt: 'processedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.FileStatus = exports.$Enums.FileStatus = {
  ACTIVE: 'ACTIVE',
  HIDDEN: 'HIDDEN',
  DISAPPROVED: 'DISAPPROVED',
  DELETED: 'DELETED'
};

exports.ListingStatus = exports.$Enums.ListingStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  STOPPED: 'STOPPED',
  CLOSED: 'CLOSED',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
  DELETED: 'DELETED'
};

exports.BidPlacedBy = exports.$Enums.BidPlacedBy = {
  USER: 'USER',
  AUTO_BID: 'AUTO_BID'
};

exports.CreditScoreRange = exports.$Enums.CreditScoreRange = {
  NOT_PROVIDED: 'NOT_PROVIDED',
  NOT_REQUIRED: 'NOT_REQUIRED',
  POOR: 'POOR',
  FAIR: 'FAIR',
  GOOD: 'GOOD',
  VERY_GOOD: 'VERY_GOOD',
  EXCELLENT: 'EXCELLENT'
};

exports.AnnualIncome = exports.$Enums.AnnualIncome = {
  NOT_PROVIDED: 'NOT_PROVIDED',
  NOT_REQUIRED: 'NOT_REQUIRED',
  UNDER_25000: 'UNDER_25000',
  FROM_25000_TO_49999: 'FROM_25000_TO_49999',
  FROM_50000_TO_74999: 'FROM_50000_TO_74999',
  FROM_75000_TO_99999: 'FROM_75000_TO_99999',
  FROM_100000_TO_149999: 'FROM_100000_TO_149999',
  MORE_THAN_150000: 'MORE_THAN_150000'
};

exports.MostRecentEviction = exports.$Enums.MostRecentEviction = {
  NOT_PROVIDED: 'NOT_PROVIDED',
  NOT_REQUIRED: 'NOT_REQUIRED',
  NEVER: 'NEVER',
  LESS_THAN_3_YEARS_AGO: 'LESS_THAN_3_YEARS_AGO',
  BETWEEN_3_AND_7_YEARS_AGO: 'BETWEEN_3_AND_7_YEARS_AGO',
  MORE_THAN_7_YEARS_AGO: 'MORE_THAN_7_YEARS_AGO'
};

exports.Prisma.ModelName = {
  User: 'User',
  Session: 'Session',
  Account: 'Account',
  Verification: 'Verification',
  Organization: 'Organization',
  Member: 'Member',
  Invitation: 'Invitation',
  Jwks: 'Jwks',
  File: 'File',
  FileAccessControl: 'FileAccessControl',
  FeaturedListing: 'FeaturedListing',
  Listing: 'Listing',
  ForLease: 'ForLease',
  AuctionFormat: 'AuctionFormat',
  Bid: 'Bid',
  SavedListing: 'SavedListing',
  Comment: 'Comment',
  Reply: 'Reply',
  Business: 'Business',
  PropertySeeker: 'PropertySeeker',
  TenantScreeningCriteria: 'TenantScreeningCriteria',
  ImpersonationLog: 'ImpersonationLog',
  ImpersonationSession: 'ImpersonationSession',
  UserSessionLog: 'UserSessionLog',
  Profile: 'Profile',
  ResendEmailLog: 'ResendEmailLog',
  ResendWebhookLog: 'ResendWebhookLog'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
